


































































































import Vue, { VueConstructor } from 'vue';
import { PageTitle, Editor } from '../../../common/components';
import { AxiosResponse, AxiosError } from 'axios';
import services from '../../../services';
import { SettingsInformation, ErrorStatesOptions } from '../../../models';
import { SettingsInformationVm, EditorType } from './viewModel';
import mapper from './mapper';
import lang from '../../../common/lang/de';
import { ToastMessage } from '@/plugins/toast/models/message';
import EventBus from '@/event-bus';
import { ConversorBytes } from '../../../common/utils/ConversorBytes';
import value from '*.json';
import { settings } from 'cluster';

const { CallCenterService } = services;
const maxSizeFileValue = 999999;

export default (Vue as VueConstructor<Vue & {
  $refs: {
    form: HTMLFormElement,
  },
  settings: SettingsInformationVm,
  formValid: boolean,
}>).extend({
  name: 'SettingsCallCenterIndex',
  components: {
    PageTitle,
    editor: Editor,
  },
  data() {
    return {
      EditorType,
      dropdownTitles: [
        'Nutzungsbestimmungen Supportanfrage',
        'Erklärung bei gesperrtem Zugang',
        'Maximale Größe für eine einzelne Anlage zu Supportanfragen in Kilo-Bytes',
        'Hinweis auf besondere Situation'
      ] as string[],
      settings: mapper.createSettingsInformationVm() as SettingsInformationVm,
      formValid: true as boolean,
      rules: {
        form: () => this.formValid,
        sizeMin: (value) => value >= 1 || 'Minimale Größe 1 KB',
        sizeMax: (value) => value <= maxSizeFileValue || 'Maximale Größe ' + maxSizeFileValue + ' KB',
        required: (value) => (!!value) || lang.formRules.required,
      } as any,
      textFieldPropsFrom: {
        appendIcon: 'event',
      },
      textFieldPropsTo: {
        appendIcon: 'event',
        rules: [(value) => this.settings.specialSituationMessage.dateTo > this.settings.specialSituationMessage.dateFrom || 'Bitte geben Sie ein Datum nach dem Datum von ein.']
      },
      dateProps: {
        headerColor: 'primary',
        color: 'primary',
        locale: 'de-De',
        firstDayOfWeek: 1,
      },
      timeProps: {
        headerColor: 'primary',
        ampmInTitle: true,
        color: 'primary',
        locale: 'de-De',
        format: '24hr'
      },
      errors: [] as string[]
    }
  },
  created() {
    this.getSettings();
  },
  computed: {
    maxSizeFile() {
      return maxSizeFileValue;
    }
  },
  methods: {
    getSettings() {
      this.$loader.show();
      CallCenterService.getSettings()
        .then((result: AxiosResponse<SettingsInformation>) => {
          this.settings = mapper.mapSettingsInformationToSettingsInformationVm(result.data);
          EventBus.$emit('dataEditor', { 'id': EditorType.TermsOfUse, 'info': this.settings.termsOfUse });
          EventBus.$emit('dataEditor', { 'id': EditorType.BlockedAccount, 'info': this.settings.blockedAccount });
          EventBus.$emit('dataEditor', { 'id': EditorType.SpecialMessage, 'info': this.settings.specialSituationMessage.message });
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
        })
        .catch((err: AxiosError) => {
          if (err.response !== undefined && (err.response.status === 401 || err.response.status === 500)) {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.NotAuthorized);
            this.$router.push('/');
          } else {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.UnexpectedError);
          }
        });
    },
    actualDateFrom(parent: any) {
      this.$set(this.settings.specialSituationMessage, 'dateFrom', new Date());
      setTimeout(() => {
        parent.okHandler();
      }, 500);
    },
    actualDateTo(parent: any) {
      this.$set(this.settings.specialSituationMessage, 'dateTo', new Date());
      setTimeout(() => {
        parent.okHandler();
      }, 500);
    },
    updateEditor($event: any, editorType: any) {
      switch (editorType) {
        case 0:
          this.settings.termsOfUse = $event;
          break;
        case 1:
          this.settings.blockedAccount = $event;
          break;
        case 2:
          this.settings.specialSituationMessage.message = $event;
          break;

      }
      this.checkForm();
    },
    checkForm() {
      this.formValid = true;

      if (this.$refs.form && !this.$refs.form.validate()) {
        this.formValid = false;
      }
      if (!(this.settings.specialSituationMessage.dateTo > this.settings.specialSituationMessage.dateFrom)) {
        this.formValid = false;
      }

      EventBus.$emit('load-settings', { 'settings': this.settings, 'formValid': this.formValid });
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    },
  }
});
